var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-properties"},[(_vm.project.id)?_c('properties-table',{attrs:{"object":_vm.project,"fields":_vm.fields}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }